import { render, staticRenderFns } from "./DocTemplateNew.vue?vue&type=template&id=6c6a9192&"
import script from "./DocTemplateNew.vue?vue&type=script&lang=ts&"
export * from "./DocTemplateNew.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports